class Header {
	constructor() {
		this.$header = $('[data-header]')
		this.$headerContent = $('[data-header-content]')
		this.$listItemWithChildren = $('[data-list-item-has-children]')
		this.$minicartToggle = $('[data-minicart-toggle]')
		this.$menuToggle = $('[data-menu-toggle]')
		this.$menuContent = $('[data-menu-content]')
		this.$closeAnnoucemnet = $('[data-close-announcement]')
		this.$annoucement = $('[data-announcement]')
		this.$linkSecondary = $('[data-nav-secondary]')
		this.$main = $('#MainContent')
		this.$body = $('body')
		this.$debounce = null
		this.annoucementItems = $('[data-annoucement-item]')
		this.annoucementList = document.querySelector('[data-annoucement-list]')
		this.hasAnnoucement = false

		this.classes = {
			active: 'active',
			navHover: 'nav--hovering',
			hideAnnoucement: 'header__annoucement--hide'
		}

		this.events()
		this.checkAnnoucementStatus({
			key: 'anoucement',
			value: 'closed'
		})

		this.mainMarginInit()
		this.accountDrop()
		this.announcementCarousel()
	}

	events() {
		this.$closeAnnoucemnet.click(e => {
			e.preventDefault()
			this.mainMarginUpdate()
			this.closeAnnoucement()
			this.setSessionState({
				key: 'anoucement',
				value: 'closed'
			})
			const headerHeight = this.$headerContent.innerHeight() + 'px'
			this.$main.css({ 'margin-top': 0 })
			if (window.innerWidth <= 1024) {
				if (this.$body.hasClass('template-index')){
					this.$body.css({ 'margin-top': headerHeight })
				}else{
					this.$body.css({ 'margin-top': 0 })
				}
			}
		})

		this.$menuToggle.click(e => {
			e.preventDefault()

			this.$menuContent.toggleClass(this.classes.active)
		})

		this.$listItemWithChildren.mouseover(e => {
			if (window.innerWidth > 768) {
				$('body').addClass(this.classes.navHover)
			}
		})

		this.$listItemWithChildren.mouseleave(e => {
			if (window.innerWidth > 768) {
				$('body').removeClass(this.classes.navHover)
			}
		})

		this.$minicartToggle.click(e => {
			e.preventDefault()

			VueMiniCart.$store.dispatch('toggleCart', true)
		})

		$(window).scroll(e => {
			if (window.innerWidth > 1024) {
				if (window.scrollY > 5) {
					this.$header.addClass('scrolled')
					$('body').addClass('scrolled')
				} else {
					this.$header.removeClass('scrolled')
					$('body').removeClass('scrolled')
				}
			}
		})

		$(document).ready(() => {
			if (window.innerWidth > 1024) {
				if (window.scrollY > 5) {
					this.$header.addClass('scrolled')
					$('body').addClass('scrolled')
				} else {
					this.$header.removeClass('scrolled')
					$('body').removeClass('scrolled')
				}
			}
		})

		this.$linkSecondary.click(e => {
			if (window.innerWidth <= 1024) {
				e.preventDefault()

				this.toggleTertiaryList(e.currentTarget)
			}
		})
	}

	setSessionState(data) {
		const { key, value } = data

		sessionStorage.setItem(key, value)
	}

	checkAnnoucementStatus(data) {
		const { key } = data
		let status = sessionStorage.getItem(key)

		if (status !== null) {
			this.closeAnnoucement()
		} else {
			this.showAnnoucement()
		}
	}

	closeAnnoucement() {
		const self = this

		this.$annoucement.slideUp(350, () => {
			self.$annoucement.addClass(self.classes.hideAnnoucement)
		})

		$('body').removeClass('announcement')
	}

	showAnnoucement() {
		const self = this

		self.$annoucement.removeClass(self.classes.hideAnnoucement)

		setTimeout(() => {
			self.mainMarginSet()
		}, 350)

		$('body').addClass('announcement')
	}

	announcementCarousel() {
		if (this.annoucementItems.length >= 2 && $('.header__annoucement').length > 0) {
			new Flickity(this.annoucementList, {
				contain: true,
				autoPlay: 5000,
				draggable: false,
				prevNextButtons: false,
				wrapAround: true
			})
		}
	}

	toggleTertiaryList(target) {
		const listTertiary = $(target).next()
		const listItemSecondary = $(target).parent()

		listTertiary.toggleClass(this.classes.active)
		listItemSecondary.toggleClass(this.classes.active)
	}

	mainMarginInit() {
		if (typeof this.$annoucement !== undefined && !this.$annoucement.hasClass('header__annoucement--hide')) {
			this.hasAnnoucement = true
			this.mainMarginTransition()
		}

		this.mainMarginSet()

		$(window).resize(e => {
			clearTimeout(this.$debounce)
			this.$debounce = setTimeout(() => {
				this.mainMarginSet()
			}, 100)
		})
	}

	mainMarginSet() {
		const buffer = this.hasAnnoucement ? (window.innerWidth >= 1025 ? 30 : 0) : 0
		const headerHeight = window.scrollY > 0 ? this.$header.outerHeight() + buffer : this.$header.outerHeight()
		const annoucementHeight = this.$annoucement.outerHeight()

		if (this.$body.hasClass('ignore-margin')) {
			if (typeof this.$annoucement !== undefined && !this.$annoucement.hasClass('header__annoucement--hide')) {
				const marginTop = window.innerWidth <= 1024 ? annoucementHeight : annoucementHeight
				this.$main.css({ 'margin-top': marginTop })
			} else {
				this.$main.css({ 'margin-top': 0 })
			}
		} else {
			if (this.$body.hasClass('template-index')){
			this.$main.css({ 'margin-top': annoucementHeight })
			}
			else{
				this.$main.css({ 'margin-top': 0 })
			}
		}
	}

	mainMarginTransition() {
		this.$main.addClass('main--transition')

		setTimeout(() => {
			this.$main.removeClass('main--transition')
		}, 500)
	}

	mainMarginUpdate() {
		const buffer = window.scrollY > 0 ? (window.innerWidth >= 1025 ? 30 : 0) : 0
		const marginTop = this.$header.outerHeight() + buffer - this.$annoucement.outerHeight()

		this.mainMarginTransition()

		if (this.$body.hasClass('ignore-margin')) {
			this.$main.css({ 'margin-top': 0 })
		} else {
			this.$main.css({ 'margin-top': marginTop })
		}
	}

	accountDrop() {
		$('[data-hover]').each((i, el) => {
			let account = $(el)

			account.on('mouseenter', () => {
				account.addClass('hover')
			})

			account.on('mouseleave', () => {
				account.removeClass('hover')
			})
		})
	}
}

new Header()
